import { ref } from 'vue'
import { defineStore } from 'pinia'
import {} from 'axios'

export const useRegistrationStore = defineStore('registration', () => {
  const currentStep = ref(0)
  const steps = ref([
    {
      id: 1,
      title: 'Introductie',
      description: '',
      pages: [1],
    },
    {
      id: 2,
      title: 'Projectgegevens',
      description: '',
      pages: [2],
    },
    {
      id: 3,
      title: "Ambitiethema's",
      description: '',
      pages: [3, 4, 5, 6, 7],
      children: [
        {
          id: 5,
          title: 'Installatiearm bouwen',
          page: 4,
        },
        {
          id: 6,
          title: 'Milieu en klimaatimpact',
          page: 5,
        },
        {
          id: 7,
          title: 'Waardebehoud',
          page: 6,
        },
        {
          id: 8,
          title: 'Uitbreidbaarheid',
          page: 7,
        },
      ],
    },
    {
      id: 9,
      title: 'Samenvatting & Afronding',
      description: '',
      pages: [8],
    },
  ])

  const registrationData = ref({
    naam: '',
    adres: '',
    plaats: '',
    schoolType: '',
    schoolTypeAdditional: [] as string[],
    opgave: '',
    ontvangerNaam: '',
    prioriteringsThemas: {
      installatiearm: false,
      milieu: false,
      waardebehoud: false,
      horizontaleUitbreiding: false,
      verticaleUitbreiding: false
    },
    email: '',
  })

  function resetRegistrationData() {
    registrationData.value = {
      naam: '',
      adres: '',
      plaats: '',
      schoolType: '',
      schoolTypeAdditional: [],
      opgave: '',
      ontvangerNaam: '',
      prioriteringsThemas: {
        installatiearm: false,
        milieu: false,
        waardebehoud: false,
        horizontaleUitbreiding: false,
        verticaleUitbreiding: false
      },
      email: '',
    }
    currentStep.value = 0
  }

  function prioriteringsThemasList() {
    const list = [] as string[]
    if (registrationData.value.prioriteringsThemas.installatiearm) {
      list.push('Installatiearm')
    }
    if (registrationData.value.prioriteringsThemas.milieu) {
      list.push('Milieu impact')
    }
    if (registrationData.value.prioriteringsThemas.horizontaleUitbreiding) {
      list.push('Horizontale uitbreidaarheid')
    }
    if (registrationData.value.prioriteringsThemas.verticaleUitbreiding) {
      list.push('Verticale uitbreidaarheid')
    }
    if (registrationData.value.prioriteringsThemas.waardebehoud) {
      list.push('Waardebehoud')
    }
    return list
  }

  function nextStep() {
    currentStep.value++
  }

  function previousStep() {
    if (currentStep.value > 0) {
      currentStep.value--
    }
  }

  function stepForPagina(pagina: number) {
    steps.value.forEach((x) => {
      if (x.pages.includes(pagina)) {
        return x
      }
    })
  }

  function typeForStep(step: number): 'dot' | 'tick' | 'empty' {
    let type: 'dot' | 'tick' | 'empty' = 'empty'

    steps.value.forEach((x) => {
      if (type == 'empty') {
        if (x.id == step) {
          let greaterThan = false
          x.pages.forEach((pageNumber) => {
            if (pageNumber == currentStep.value) {
              type = 'dot'
            } else if (pageNumber <= currentStep.value) {
              greaterThan = true
            }
          })
          if (greaterThan && type == 'empty') {
            type = 'tick'
          }
        } else if (x.children) {
          x.children.forEach((child) => {
            if (child.id == step) {
              if (child.page == currentStep.value) {
                type = 'dot'
              } else if (child.page <= currentStep.value) {
                type = 'tick'
              }
            }
          })
        }
      }
    })
    return type
  }

  return {
    steps,
    currentStep,
    previousStep,
    nextStep,
    stepForPagina,
    typeForStep,
    registrationData,
    resetRegistrationData,
    prioriteringsThemasList,
  }
})
